import { TextField } from "@mui/material";
import React from "react";
import { DatePicker, PickersDay } from "@mui/x-date-pickers";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";

const CommonDatePicker = ({
  name,
  size,
  label,
  pickerFormat,
  DefaultDTvalue,
  handleChange,
  openTo,
  views = ["year", "month", "day"],
  error,
  helperText,
  variant,
  maxDate,
  minDate,
  disableDates,
  disabled,
  required,
  onKeyPress,
  onKeyDown,
  textFieldSx,
  autoFocus
}) => {
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <DatePicker
        {...(openTo && {
          openTo: openTo,
        })}
        views={views}
        shouldDisableDate={disableDates}
        minDate={minDate}
        maxDate={maxDate}
        name={name}
        label={label}
        inputFormat={pickerFormat}
        value={DefaultDTvalue}
        onChange={handleChange}
        disabled={disabled}
        renderDay={(day, _value, DayComponentProps) => {
          const shouldDisable = disableDates?.(day) || false;
          const disabledDate = DayComponentProps.disabled || shouldDisable;

          return (
            <PickersDay
              {...DayComponentProps}
              disabled={DayComponentProps.disabled}
              sx={{
                ...(disabledDate && {
                  opacity: 0.35,
                  ...(shouldDisable && {color: "rgba(0,0,0,0.45)",
                  backgroundColor: "rgba(0,0,0,0.06)",
                  border: "1px solid rgba(0,0,0,0.08)",
                  borderRadius: "50%",})
                }),
              }}
            />
          );
        }}

        renderInput={(params) => <TextField {...params} autoFocus={autoFocus} variant={variant} onKeyDown={onKeyDown} onKeyPress={onKeyPress} disabled={disabled} size={size} error={error !== undefined ? Boolean(error) : false} required={required} helperText={helperText !== undefined ? helperText : ""} sx={textFieldSx} 
        inputProps={{
          ...params.inputProps,
          readOnly: true,
        }}
          {...(textFieldSx?.isPreRegistration && {
            InputProps: {
              ...params.InputProps,
              disableUnderline: true,
              sx: {
                "& .MuiSvgIcon-root": {
                  fontSize: "30px",
                },
              },
            },
          })}
        />}
      />
    </LocalizationProvider>
  );
};

export default CommonDatePicker;